import styled from '@emotion/styled'
import { DASH_NAV_WIDTH } from '../../../legacy/common/theme'

export const AppContentContainer = styled.div({
  position: 'absolute',
  width: `calc(100% - ${DASH_NAV_WIDTH})`,
  minHeight: '100%',
  height: '100%',
  left: DASH_NAV_WIDTH,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
})
